import { Instance } from 'mobx-state-tree';
import { CompletedRoutesInsightsOverTimeDtoModelBase } from './CompletedRoutesInsightsOverTimeDtoModel.base';

/* The TypeScript type of an instance of CompletedRoutesInsightsOverTimeDtoModel */
export interface CompletedRoutesInsightsOverTimeDtoModelType extends Instance<typeof CompletedRoutesInsightsOverTimeDtoModel.Type> {}

/* A graphql query fragment builders for CompletedRoutesInsightsOverTimeDtoModel */
export { selectFromCompletedRoutesInsightsOverTimeDto, completedRoutesInsightsOverTimeDtoModelPrimitives, CompletedRoutesInsightsOverTimeDtoModelSelector } from './CompletedRoutesInsightsOverTimeDtoModel.base';

/**
 * CompletedRoutesInsightsOverTimeDtoModel
 */
export const CompletedRoutesInsightsOverTimeDtoModel = CompletedRoutesInsightsOverTimeDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
